import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ToastProvider } from 'react-toast-notifications';
import { makeStyles } from "@material-ui/core/styles";

import routes from "routes.js";
import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import SignIn from "../views/SignIn/SignIn";
import Registrar from "../views/Registrar/Registrar";
import Historico from "../views/Historico/Historico";
import Configuracao from "../views/Configuracao/Configuracao";
import Justificativa from "../views/Justificativa/Justificativa";
import RecuperarSenhaSolicitar from "../views/RecuperarSenha/Solicitar";
import RecuperarSenhaVerificacao from "../views/RecuperarSenha/Verificacao";
import RecuperarSenhaConfirmacao from "../views/RecuperarSenha/Confirmacao";
import NotFound from "../views/NotFound/NotFound";
import ConfirmaDados from "../views/ConfirmaDados/ConfirmaDados";
import TrocaSenha from "../views/TrocaSenha/TrocaSenha";
import Lgpd from "../views/LGPD/LGPD";
import Restrito from "../views/Restrito/Restrito";

import "perfect-scrollbar/css/perfect-scrollbar.css";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import imageLogo from '../assets/pontojob_logo_branco.png';
import imageLogoTalentRh from '../assets/logo_talent.png';
import imageLogoViasoft from '../assets/logo_viasoft.png';

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
  <Route {...rest} render={props =>
      auth ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  const classes = useStyles();
  const mainPanel = React.createRef();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  useEffect(() => {
    const connected = localStorage.getItem('connected');
    if (connected === 'false') {
      localStorage.clear();
    }
  }, []);
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  }

  const switchRoutes = (
    <Route>
      <Switch>
        <Route exact path="/" component={SignIn} />
        <Route path="/recuperarsenha/solicitar" component={RecuperarSenhaSolicitar} />
        <Route path="/recuperarsenha/verificar" component={RecuperarSenhaVerificacao} />
        <Route path="/recuperarsenha/confirmar" component={RecuperarSenhaConfirmacao} />
        <PrivateRoute path="/registrar" component={Registrar} auth={isAuthenticated()} />
        <PrivateRoute path="/historico" component={Historico} auth={isAuthenticated()} />
        <PrivateRoute path="/configuracao" component={Configuracao} auth={isAuthenticated()} />
        <PrivateRoute path="/justificativa" component={Justificativa} auth={isAuthenticated()} />
        <PrivateRoute path="/confirmadados" component={ConfirmaDados} auth={isAuthenticated()} />
        <PrivateRoute path="/trocasenha" component={TrocaSenha} auth={isAuthenticated()} />
        <PrivateRoute path="/lgpd" component={Lgpd} auth={isAuthenticated()} />
        <PrivateRoute path="/restrito" component={Restrito} auth={isAuthenticated()} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Route>
  );
  
  const footer = () => {
    return (
      <div style={{
        textAlign: "center",
        padding: "30px",
        left: "0",
        bottom: "0",
        position: 'fixed',
        width: "100%"
      }}>
        <img src={imageLogoViasoft} alt="Logo" width={169} />
      </div>
    );
  }

  if (isAuthenticated()) {
    return (
      <ToastProvider autoDismiss={true} autoDismissTimeout={10000}>
        <div className={classes.wrapper} style={{ backgroundColor: '#f8f9fd' }}>
          <img alt="" src={imageLogo} style={{ width: 150, top: 30, left: 90, position: 'absolute' }}></img>
          <img alt="" src={imageLogoTalentRh} style={{ width: 150, top: 30, right: 30, position: 'absolute' }} />
          <Sidebar
            routes={routes}
            logoText={""}
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            color="blue"
          />
          <div style={{ backgroundColor: '#f8f9fd', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', width: '100%', height: '100%', backgroundImage: "url(../../back.png)" }} >
            <div className={classes.mainPanel} ref={mainPanel} style={{ overflowY: 'hidden !important' }}>
              <Navbar
                routes={routes}
                handleDrawerToggle={handleDrawerToggle}
                {...rest}
              />
              <div className={classes.content}>
                <div className={classes.container}>{switchRoutes}</div>
              </div>
            </div>
          </div>
        </div>
        {footer()}
      </ToastProvider>
    );
  } else {
    return (
      <ToastProvider autoDismiss={true} autoDismissTimeout={8000}>
        <div className={classes.wrapper} style={{ backgroundColor: '#f8f9fd' }}>
          <img alt="" src={imageLogo} style={{ width: 150, top: 30, left: 30, position: 'absolute' }}></img>
          <img alt="" src={imageLogoTalentRh} style={{ width: 150, top: 30, right: 30, position: 'absolute' }} />
          <div style={{ backgroundColor: '#f8f9fd', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', width: '100%', height: '100%', backgroundImage: "url(../../back.png)" }} >
            <div className={classes.mainPanel} ref={mainPanel} style={{ overflowY: 'hidden !important' }}>
              <div className={classes.wrapper}>
                <div className={classes.container}>{switchRoutes}</div>
              </div>
            </div>
          </div>
        </div>
        {footer()}
      </ToastProvider>
    );
  }
}
